import { colorForAgent } from '@wix/ai-scheduling-assistant-common-lib/entities';
import { useTranslation } from '../../../../lib/i18n';
import type { MentionAgent } from '../../../../lib/agent-mentions';
import { ScrollArea } from '../../ui';
import styles from './AgentMentionPanel.module.css';

// The @-mention panel floating above the composer: the user's agents (shared
// identity color dot + name), filtered by what was typed after the `@`. Web is
// agents-only — contacts stay on the "+" menu (there is no merged panel here).
// Test tags mirror the native surfaces: chat.mention.panel / chat.mention.agentRow.
export function AgentMentionPanel({ agents, onPick }: { agents: MentionAgent[]; onPick: (agent: MentionAgent) => void }) {
  const { t } = useTranslation();
  return (
    <ScrollArea className={styles.panel} data-testid="chat.mention.panel">
      <div className={styles.header}>{t('chat.mention.agentsSection')}</div>
      {agents.length === 0 ? (
        <div className={styles.empty}>{t('chat.mention.noAgents')}</div>
      ) : (
        agents.map((agent) => (
          <button
            key={agent.id}
            type="button"
            className={styles.row}
            data-testid="chat.mention.agentRow"
            // Keep the textarea focused through the pick — a mousedown blur would
            // close the keyboard/caret before the click lands.
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onPick(agent)}
          >
            <span aria-hidden className={styles.dot} style={{ background: colorForAgent(agent.id || agent.name) }} />
            <span className={styles.name}>{agent.name}</span>
          </button>
        ))
      )}
    </ScrollArea>
  );
}
